import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import DirectoryPage from "./pages/DirectoryPage";
import MyStoryPage from "./pages/MyStoryPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/directory" element={<DirectoryPage />} />
                    <Route path="/my-story" element={<MyStoryPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
